























import Vue from 'vue';
import { mapGetters } from 'vuex';
import { DoorConfiguration } from '../../../configurator/DoorConfiguration';

export default Vue.extend({
    name: 'RMountingMaterial',
    computed: {
    ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration']),
        currentDoorConfiguration() {
            return this.getCurrentDoorConfiguration.Get(DoorConfiguration.MountingMaterial);
        }
    },
    methods: {
        
    },
    mounted() {
        
    }
})
